import React, { useState } from "react";

import {
  GlobalEfficiency,
  GroupEfficiency,
  SosEfficiency,
  DateRange,
} from "../components";

const Efficiency = () => {
  const [range, setRange] = useState(null);

  return (
    <div className="container has-background-light p-6 mt-5">
      <DateRange range={range} setRange={setRange} />

      {range ? (
        <div className="columns is-multiline">
          <div className="column is-12">
            <SosEfficiency range={range} />
          </div>
          <div className="column is-6">
            <GlobalEfficiency range={range} />
          </div>
          <div className="column is-6">
            <GroupEfficiency range={range} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Efficiency;
